import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoriesAPI, getImageUrl } from '../utils/api';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await categoriesAPI.getAll({ status: 'active' });
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return (
    <>

      <section className="bg-gradient-to-br from-db-dark to-blue-900 text-white py-8 sm:py-12 lg:py-16">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <nav className="text-xs sm:text-sm text-gray-300 mb-6 sm:mb-8" data-aos="fade-right">
            <Link to="/" className="hover:text-white transition">Home</Link> /
            <span className="text-white font-semibold">Product Categories</span>
          </nav>
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6" data-aos="fade-up">Product Categories</h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-6 sm:mb-8 px-4" data-aos="fade-up" data-aos-delay="200">
              Explore our comprehensive range of industrial automation and control solutions
            </p>
          </div>
        </div>
      </section>

      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          {loading ? (
            <div className="text-center py-12">
              <p className="text-gray-600">Loading categories...</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {categories.map((category, index) => (
                <Link
                  key={category._id}
                  to={`/categories/${category.slug}`}
                  className="category-card group bg-white rounded-lg shadow-lg overflow-hidden hover-lift card-shine block transition-all duration-300"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                    <img
                      src={getImageUrl(category.image) || 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600'}
                      alt={category.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70"></div>
                    <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 right-3 sm:right-4">
                      <div className="flex items-center justify-between text-white">
                        <div>
                          <div className="text-xl sm:text-2xl font-bold">{category.name}</div>
                          <div className="text-xs sm:text-sm text-gray-300">{category.productCount || 0} Products Available</div>
                        </div>
                        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 rounded-full flex items-center justify-center icon-rotate">
                          <i className={`${category.iconClass || 'fas fa-box'} text-lg sm:text-xl`}></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-6">
                    <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">{category.description || 'Explore our products in this category'}</p>
                    <div className="block w-full bg-gradient-to-r from-db-blue to-blue-700 group-hover:from-blue-700 group-hover:to-blue-800 text-white font-semibold py-2.5 sm:py-3 px-4 rounded-lg transition text-center text-sm sm:text-base">
                      Explore {category.name} <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Categories;

